// Auto-generated (frontend-only, no PHP). Proxy makes route() tolerant of unknown names.
const knownRoutes = {
  "users.show": {
    "uri": "users/{user}/{mode?}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "users.page": {
    "uri": "users/{user}/page",
    "methods": [
      "PUT"
    ]
  },
  "users.extra-page": {
    "uri": "users/{user}/extra-pages/{page}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "users.posts": {
    "uri": "users/{user}/posts",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "users.modding.index": {
    "uri": "users/{user}/modding",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "users.multiplayer.index": {
    "uri": "users/{user}/multiplayer",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "account.edit": {
    "uri": "home/account/edit",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "account.cover": {
    "uri": "account/cover",
    "methods": [
      "PUT"
    ]
  },
  "account.options": {
    "uri": "account/options",
    "methods": [
      "PUT"
    ]
  },
  "account.update": {
    "uri": "account/update",
    "methods": [
      "PUT"
    ]
  },
  "score-pins.reorder": {
    "uri": "score-pins/reorder",
    "methods": [
      "POST"
    ]
  },
  "comments.index": {
    "uri": "comments",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "messages.users.show": {
    "uri": "messages/users/{user}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "rankings": {
    "uri": "rankings/{mode}/{type}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "seasons.show": {
    "uri": "seasons/{season}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "store.products.show": {
    "uri": "store/products/{product}",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "support-the-game": {
    "uri": "home/support",
    "methods": [
      "GET",
      "HEAD"
    ]
  },
  "teams.show": {
    "uri": "teams/{team}",
    "methods": [
      "GET",
      "HEAD"
    ]
  }
};
const routesProxy = new Proxy(knownRoutes, {
  get(target, prop) {
    if (typeof prop !== 'string') return target[prop];
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    return { uri: prop.replace(/\./g, '/'), methods: ['GET', 'HEAD'] };
  },
  has() { return true; },
});
const Ziggy = { url: 'http://localhost', port: null, defaults: {}, routes: routesProxy };
export { Ziggy };
